import axios from 'axios'
import { get } from 'lodash'
import qs from 'qs'
import React from 'react'
import * as interfaces from '../static/interfaces'
import I18n from 'core/i18n'

declare var window: interfaces.IWindow

const getCSRFToken = () => {
  const element: any = document.querySelector('meta[name=csrf-token]')
  return element.content
}

const axiosClient = axios.create({
  withCredentials: true,
})

axiosClient.interceptors.request.use(
  config => {
    config.headers['X-CSRF-Token'] = getCSRFToken()
    config.headers['X-Requested-With'] = 'XMLHttpRequest'

    // enable nested object
    // https://github.com/axios/axios/issues/738
    config.paramsSerializer = params => {
      return qs.stringify(params, {
        arrayFormat: 'brackets',
        encode: false,
      })
    }
    return config
  },
  error => Promise.reject(error)
)

axiosClient.interceptors.response.use(
  response => response,
  error => {
    const message = get(error, 'response.data.errors') || error.message

    // ネットワークエラー等でレスポンスが存在しない場合
    if (!error.response) {
      window.globalModal.showModal({
        title: I18n.t('generic.system_error'),
        body: <p>{I18n.t('generic.system_error_text')}</p>,
        submitText: I18n.t('generic.reload'),
        handleSubmit: () => location.reload(),
        hideCloseIcon: true,
      })
      return Promise.reject(error)
    }

    if (error.response.data?.flush) {
      window.flashMessages.addMessage({ text: error.response.data.flush.message, type: 'error' })
    } else if (error.response.status === 422) {
      if (typeof message === 'string') {
        window.flashMessages.addMessage({ text: message, type: 'error' })
      } else if (message instanceof Array) {
        message.map(val => window.flashMessages.addMessage({ text: val, type: 'error' }))
      }
      return Promise.reject(error)
    } else if (error.response.status === 408) {
      return Promise.reject(error)
    } else if (error.response.status === 401) {
      return Promise.reject(error)
    } else if (error.response.status === 403) {
      const permissionMessage =
        typeof message === 'string' ? message : I18n.t('generic.permission_denied')
      window.globalModal.showModal({
        title: I18n.t('generic.permission_denied_title'),
        body: <p>{permissionMessage}</p>,
        closeText: I18n.t('generic.close'),
      })
      return Promise.reject(error)
    } else {
      window.globalModal.showModal({
        title: typeof message === 'string' ? message : I18n.t('generic.system_error'),
        body: <p>{I18n.t('generic.system_error_text')}</p>,
        submitText: I18n.t('generic.reload'),
        handleSubmit: () => location.reload(),
        hideCloseIcon: true,
      })
      return Promise.reject(error)
    }
  }
)

export default axiosClient
